import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'grabaciones-historicas';
  show_navbar = false;
  code: string | null = null;
  constructor(private authService: AuthService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    // console.log("CARGA APP");
    // this.route.queryParams.subscribe((params) => {
    //   if (params['code']) {
    //     this.code = params['code']; // Guarda el parámetro en una variable
    //     console.log('El parámetro code es:', this.code);
    //     this.authService.getToken(this.code).subscribe((data) => {
    //       console.log('data', data);
    //     });
    //     this.authService.isAuthenticated().subscribe((isAuthenticated) => {
    //       this.authService.configuration$.subscribe((config) => {
    //         console.warn('Config: ', config);
    
    //       })
    //       console.log('app authenticated', isAuthenticated);
    //     })
    //   } else {
    //     console.log('No se encontró el parámetro code en la URL.');
    //   }
    // });
    
  }

}
